@import '../../theme/global.scss';

:host {
  align-items: center;
  display: flex;
  justify-content: center;


  .test {
    margin-right: 1.0rem;
  }

  .org-admin-container {
    display: flex;
  }

  .messaging-container {
    display: flex;
  }

  .app-switcher-container {
    display: flex;

    snap-app-switcher {
      margin-right: 1.0rem;
    }
  }

  .divider-bar {
    background-color: $gray-300;
    height: 1.5rem;
    margin-right: 1.0rem;
    width: 1px;
  }
}
